export { DrillPageSentenceStrip } from "#drill-page-sentence-strip";
